import { ReactNode } from 'react';
import styles from './ContentContainer.module.scss';

interface Props {
  children: ReactNode;
}

export default function ContentContainer({ children }: Props) {
  return <div className={styles.Container}>{children}</div>;
}
